import {ProfileType} from "../ClientManagement/models/ProfileResponse";
import {selectApprovedProfile, selectProfile} from "../ClientManagement/ClientProfile/activeProfileSlice";
import {useAppSelector} from "../store/hooks";
import {selectProposals} from "../ClientManagement/Proposals/proposalsSlice";
import {selectIsNationalSampleAdmin} from "../Authorization/nationalSampleAdminSlice";

export type ProfileEditableState = {
    isArchiveReadOnly: boolean;
    isProfileWithProposalsReadOnly: boolean;
    isProfileWithProposalsOrArchived: boolean;
    isArchivedActiveClient: boolean;
    isApprovedProfileArchived: boolean;
    isNationalSampleReadOnly: boolean;
    isNationalSampleAdmin: boolean;
}

const useProfileEditableState = (): ProfileEditableState => {
    const profileState = useAppSelector(selectProfile);
    const proposalsState = useAppSelector(selectProposals);
    const approvedProfileState = useAppSelector(selectApprovedProfile);
    const isNationalSampleAdmin = useAppSelector(selectIsNationalSampleAdmin);

    const isNationalSampleReadOnly = !!profileState?.sample && !!profileState?.isNationalSample && !isNationalSampleAdmin;

    // Read Only Flags
    const isArchiveReadOnly = profileState?.archived || !profileState.activeClient || isNationalSampleReadOnly;
    const isProfileWithProposalsReadOnly = profileState.type === ProfileType.PROFILE && proposalsState.length > 0;

    // Archived Flags
    const isApprovedProfileArchived = approvedProfileState?.archived || !approvedProfileState.activeClient;
    const isProfileWithProposalsOrArchived = profileState?.archived || !profileState.activeClient || isProfileWithProposalsReadOnly || isNationalSampleReadOnly;
    const isArchivedActiveClient = profileState?.archived && profileState?.activeClient;

    return {
        isArchiveReadOnly,
        isProfileWithProposalsReadOnly,
        isProfileWithProposalsOrArchived,
        isArchivedActiveClient,
        isApprovedProfileArchived,
        isNationalSampleReadOnly,
        isNationalSampleAdmin
    };
}

export default useProfileEditableState;
